import { render, staticRenderFns } from "./bulk-edit.vue?vue&type=template&id=3277874c&scoped=true&"
import script from "./bulk-edit.vue?vue&type=script&lang=ts&"
export * from "./bulk-edit.vue?vue&type=script&lang=ts&"
import style0 from "./bulk-edit.vue?vue&type=style&index=0&id=3277874c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3277874c",
  null
  
)

export default component.exports